"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var Button = __importStar(require("./A_Button"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
var Component = function (p) {
    var alertAction = (Preact.h(Preact.Fragment, null,
        p.buttonText ? (Preact.h(Button.Component, { color: "inherit", size: "small", onClick: p.buttonAction, sx: { minWidth: 'min-content' } }, p.buttonText.toUpperCase())) : null,
        Preact.h(Button.Component, { color: "inherit", size: "small", onClick: p.onCloseClick, sx: { minWidth: 'min-content', paddingTop: '2px' } },
            Preact.h(Close_1.default, { fontSize: "small" }))));
    return (Preact.h(Snackbar_1.default, { open: p.show, sx: __assign({}, p.sx) },
        Preact.h(Alert_1.default, { severity: p.color, action: alertAction, variant: "filled", sx: {
                /* For some reason the standard Alert doesn't vertically center the message text or action buttons. This makes it behave */
                '.MuiAlert-message': {
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '10px',
                },
                '.MuiAlert-action': {
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '2px',
                },
                flexGrow: 1,
            } },
            Preact.h(Typography_1.default, { variant: "body2" },
                " ",
                p.text))));
};
exports.Component = Component;
